import script from "./loadingScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./loadingScreen.vue?vue&type=script&setup=true&lang=ts"

import "./loadingScreen.vue?vue&type=style&index=0&id=6c5de8bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c5de8bf"]])

export default __exports__